module.exports={ 
    TIPOGRAM_CONTRACT_ADDRESS:"0xE8bDf1f1A050255bf79d4e5F78244D5F17b13300"
}